"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isScheduleResource(object) {
    return checkScheduleResource(object).fulfilled;
}
exports.isScheduleResource = isScheduleResource;
function checkScheduleResource(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("name")).withOptions(options).explain();
}
exports.checkScheduleResource = checkScheduleResource;
//# sourceMappingURL=ScheduleResource.js.map